<template>
  <div
    v-tooltip="$t('COMMUNICATION.TOOL.RESET_RING_CENTRAL')"
    data-cy="reset-ringcentral"
    class="h-[24px] w-[24px] transform cursor-pointer transition-all duration-300 hover:-rotate-180"
    @click="emit('ring-central:reset', $event)"
  >
    <icon-base icon="reload" height="24" width="24" />
  </div>
</template>

<script setup lang="ts">
const emit = defineEmits<{
  "ring-central:reset": [MouseEvent];
}>();
</script>
